import type { FC } from 'react'
import { useState } from 'react'
import cn from 'classnames'
import { Link, Button } from 'components/ui'
import { useRouter } from 'next/router'
import { ChevronDown, ChevronUp } from 'components/icons'
import type { FilterLinkProps } from '.'
import s from './filter-link.module.css'
import { FilterBlock } from '..'

const FilterLink: FC<FilterLinkProps> = ({
  title = '',
  baseUrl,
  preserveQuery = true,
  className,
  filters,
  vertical = false,
}) => {
  const router = useRouter()

  const [open, setOpen] = useState<string[]>([])

  if (!filters) {
    return <></>
  }

  function toggle(slug: string) {
    if (open.includes(slug)) {
      const nextOpen = open.filter((e: string) => e !== slug)
      setOpen([...nextOpen])
    } else {
      const nextOpen = open
      nextOpen.push(slug)
      setOpen([...nextOpen])
    }
  }

  // router.query['categories'][0]

  const currentQuery = preserveQuery ? router.query : {}
  currentQuery.page = '1'

  return (
    <FilterBlock title={title} className={cn(s.root, className)} vertical>
      <ul className={cn(vertical && s.vertical)}>
        {filters.map(({ id, slug, name, categories }) => (
          <li key={`filter-link-${id}`}>
            {categories && categories.length > 0 ? (
              <button type="button" className={s.filterLink} onClick={() => toggle(slug)}>
                <span>{name}</span>
                {categories && categories.length > 0 && (
                  <Button variant="text">{open.includes(slug) ? <ChevronUp /> : <ChevronDown />}</Button>
                )}
              </button>
            ) : (
              <Link href={{ pathname: `${baseUrl}${slug}`, query: currentQuery }} className={s.filterLink}>
                <span>{name}</span>
                {categories && categories.length > 0 && (
                  <Button variant="text" onClick={() => toggle(slug)}>
                    {open.includes(slug) ? <ChevronUp /> : <ChevronDown />}
                  </Button>
                )}
              </Link>
            )}
            {open.includes(slug) && (
              <ul className={cn(vertical && s.vertical, s.subcategory)}>
                {categories &&
                  categories.length > 0 &&
                  categories.map((sub) => (
                    <Link href={{ pathname: `${baseUrl}${sub.slug}`, query: currentQuery }} className={s.filterLink}>
                      {sub.name}
                    </Link>
                  ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </FilterBlock>
  )
}

export default FilterLink
